import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { fetchStoreSuggestion } from './actions'
import { Stores } from './reducer'
import CardStore from 'Catalog/Vendor/CardStore/CardStore'

import '@loyal_template/stores.css'

class StoreSuggestion extends Component {
  componentDidMount () {
    this.props.fetchStoreSuggestion()
  }

  render () {
    if (this.props.onlyCash) {
      return ''
    }
    const storesTemp = this.props.stores || []
    return (
      storesTemp && storesTemp.length > 0 && (
        <div className='stores-showcase-ordination col-12 px-0'>
          <div className='bx-showcase bx-showcase-stores container-fluid bg-ui-5 mx-0 mx-md-auto px-0 py-3'>
            <div className='container-stores container mx-2 mx-auto px-0 px-md-1'>
              <div className='row mx-0'>
                <div className='col-auto mr-auto mb-2 mb-md-4 mx-0 px-0'>
                  <h2 className='txt-font-title color-title d-none d-md-block px-md-0 px-2'>
                    Encontre as suas lojas favoritas.
                  </h2>
                  <h2 className='txt-font-title color-title d-block d-md-none px-md-0 px-2'>
                    Marcas
                  </h2>
                </div>
              </div>
              <div className='showcase-stores row mx-0'>
                {renderCardStores(
                  this.props.stores,
                  'col-6 col-md-3 my-half mx-half px-half py-half'
                )}
              </div>
            </div>
          </div>
        </div>
      )
    )
  }
}

const renderCardStores = (stores, className = '') =>
  stores.map((ItemStore, index) => {
    let link = ItemStore.link
    if (!link) {
      link = `/vendor?vendor=${ItemStore.id}`
    }
    let vendor = {
      description: ItemStore.name,
      vendorId: ItemStore.id,
      vendorImage: ItemStore.imageUrl
    }
    return (
      <Fragment>
        <div
          key={index}
          className={`item card vendor_${ItemStore.id} ${className}`}>
          <div className='row mx-0'>
            <div className='col-md-12'>
              <Link to={link}>
                <CardStore informations={vendor} />
              </Link>
            </div>
          </div>
        </div>
      </Fragment>
    )
  })

StoreSuggestion.propTypes = {
  fetchStoreSuggestion: PropTypes.func,
  stores: PropTypes.array,
  onlyCash: PropTypes.bool
}

const mapStateToProps = ({ storeSuggestion, onlyCash }) => {
  return ({
    ...Stores(storeSuggestion),
    onlyCash
  })
}

const mapDispatchToProps = dispatch => ({
  fetchStoreSuggestion: () => dispatch(fetchStoreSuggestion('home'))
})

export default connect(mapStateToProps, mapDispatchToProps)(StoreSuggestion)



// WEBPACK FOOTER //
// ./src/features/Suggestion/StoreSuggestion/StoreSuggestion.js